import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';

class NewConversation extends Component {

    render() {
        return (
            <div className="s360-new-conversation-tab" style={this.newConversationStyle()} onClick={this.startConversation}>
                <div className="s360-new-conversation-tab-image">
                {this.attachmentSVGImage(this.props.config.designDetails.headerColor)}
                </div>
                <div className="s360-new-conversation-tab-text" style={this.newConversationTextStyle()}>
                    New Conversation
                </div>
            </div>
        )
    }

    attachmentSVGImage = (imageColor, width, height) => {
        return <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width={width || "100%"} height={height || "100%"}
            viewBox="0 0 172 172"
            style={{ fill: imageColor }}><g fill="none" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" strokeMiterlimit="10" strokeDasharray="" strokeDashoffset="0" fontFamily="none" fontWeight="none" fontSize="none" textAnchor="none" style={{ mixBlendMode: "normal" }}><path d="M0,172v-172h172v172z" fill="none"></path><g fill={imageColor}><path d="M86,14.33333c-39.5815,0 -71.66667,32.08517 -71.66667,71.66667c0,39.5815 32.08517,71.66667 71.66667,71.66667c39.5815,0 71.66667,-32.08517 71.66667,-71.66667c0,-39.5815 -32.08517,-71.66667 -71.66667,-71.66667zM121.83333,93.16667h-28.66667v28.66667h-14.33333v-28.66667h-28.66667v-14.33333h28.66667v-28.66667h14.33333v28.66667h28.66667z"></path></g></g></svg>
    }

    startConversation = () => {
        // Move to the conversation screen.
        this.props.landingPageActions.startNewConversation();
    }

    newConversationStyle = () => {
        return {
            borderColor: this.props.config.designDetails.headerColor,
        }
    }

    newConversationTextStyle = () => {
        return {
            color:      this.props.config.designDetails.selectionButtonTextColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
        }
    }
}
export default NewConversation;